import api from '@/api/auditlog'
import { errorHandler } from '../exports/error_management'

const state = {
    items: [],
    pagination: null,
    types: []
}

const mutations = {
    set(state, payload) {
        state.items = payload
    },
    set_type(state, payload) {
        state.types = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
}

const actions = {
    fetch(context, payload) {
        return api
            .fetch(payload)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    //result.data.success.data.data
                    let users = pag.data
                    context.commit('set', users)
                    //let pag = result.data.success.data
                    context.commit('set_pagination', {
                        page: pag.current_page,
                        pageSize: pag.per_page,
                        total: pag.total,
                    })
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    types(context) {
        return api
            .types()
            .then(({
                data: {
                    success: { data: typeData },
                },
            }) => context.commit("set_type", typeData))
            .catch(err => {
                errorHandler(err)
            })
    },
    delete(context, id) {
        return api
            .delete(id)
            .then(() => context.commit('delete', id))
            .catch(err => {
                errorHandler(err)
            })
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}